import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash.isequal';

// Selectors
import { selectFilteredData } from '../../../ReportsHarvestInspectionsTable/selectors';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

const makeSelectFieldAverage = () =>
    createDeepEqualSelector([selectFilteredData], filteredDataState => {
        if (!filteredDataState || !filteredDataState.length) return 0;
        const totalNumberOfDefectedApples = filteredDataState.reduce(
            (acc, cur) => {
                if (!cur.numberOfDefectedApples) return acc;
                return acc + cur.numberOfDefectedApples;
            },
            0
        );
        const totalNumberOfApples = filteredDataState.reduce((acc, cur) => {
            if (!cur.numberOfApples) return acc;
            return acc + cur.numberOfApples;
        }, 0);
        if (!totalNumberOfDefectedApples || !totalNumberOfApples) return 0;
        const average =
            (totalNumberOfDefectedApples / totalNumberOfApples) * 100;
        return Math.ceil(average * 100) / 100;
    });

export { makeSelectFieldAverage };
